import workspaceQuery from '../../../graphql/queries/company/EmailPrintPreviewWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/company/EmailPrintPreviewQuery.graphql';
import defaultQuery from '../../../graphql/queries/company/EmailPrintPreviewDefault.graphql';
import mutationQuery from '../../../graphql/mutations/company/EmailPrintPreviewMutation.graphql';
import fragment from '../../../graphql/fragments/company/EmailPrintPreviewFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const EmailPrintPreview: EntityType = {
  type: 'EmailPrintPreview',
  title: 'Email Print Previews',
  formTitle: 'Email Print Preview',
  formUrl: '/Company/EmailPrintPreview/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'EMAIL_PRINT_PREVIEW',
};

export default EmailPrintPreview;
